export { ConfirmationTemplate } from './ConfirmationTemplate';
export type {
  ConfirmationBookingItem,
  ConfirmationTemplateLabels,
  ConfirmationTemplateProps,
  ConfirmationUpsellItem,
} from './ConfirmationTemplate.types';
